module.exports = __webpack_public_path__ + "static/img/pingjieshen5.4a58b839.png";